export interface BoelsPostalCodeHandlerMap {
  [countryCode: string]: {
    isValidFormat: (zipcode: string) => boolean;
    positionOfSpace: number;
    placeholderText: string;
    validationMessage: string;
  };
}

export enum PostalCodeTranslations {
  NL = 'De postcode moet bijvoorbeeld 1234 AB zijn.',
  PL = 'Kod pocztowy musi być 12-345 na przykład.',
  SK = 'PSČ musí byť napríklad 123 45.',
  FallbackNL = 'The zip code has to be 1234 AB for example.',
  FallbackPL = 'The zip code has to be 12-345 for example.',
  FallbackSk = 'The zip code has to be 123 45 for example.',
}

export interface PostalCode {
  postalCodePlaceholder: string;
  postalCodeValidationMessage: string;
  postalCodePositionOfSpace: number;
}
